// extracted by mini-css-extract-plugin
export var createdDate = "_kb-1";
export var divider = "_kb-2";
export var headerDivider = "_kb-3";
export var messagesCard = "_kb-0";
export var messagesContainer = "_kb-7";
export var messagesContainerWrapper = "_kb-4";
export var pointerCapturingButtonBoxes = "_kb-a";
export var showLeftPanelButton = "_kb-9";
export var showMoreButton = "_kb-c";
export var showMoreButtonContainer = "_kb-b";
export var summaryTitle = "_kb-6";
export var systemMessageCardWrapper = "_kb-d";
export var topButtons = "_kb-8";
export var withPadding = "_kb-5";